import { DracoLoader as DracoWorkerLoader } from './draco-loader';
import DracoParser from './lib/draco-parser';
import { loadDracoDecoderModule } from './lib/draco-module-loader';
export { DracoWriter } from './draco-writer';
export { DracoWorkerLoader };
export const DracoLoader = { ...DracoWorkerLoader,
  parse
};

async function parse(arrayBuffer, options) {
  const {
    draco
  } = await loadDracoDecoderModule(options);
  const dracoParser = new DracoParser(draco);

  try {
    return dracoParser.parseSync(arrayBuffer, options === null || options === void 0 ? void 0 : options.draco);
  } finally {
    dracoParser.destroy();
  }
}

export const _TypecheckDracoLoader = DracoLoader;
//# sourceMappingURL=index.js.map